import React from "react";
import { Box } from "@mui/material";
import Calendar from "../Calendar"; // Adjust path as needed

const ViolationCalendarTab = ({ violation_id, currentUserId }) => {
  return (
    <Box>
      <Calendar
        defaultView="month"
        violation_id={violation_id}
        currentUserId={currentUserId}
      />
    </Box>
  );
};

export default ViolationCalendarTab;
